import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
    AtomsProvider,
    LocalizationContextProvider,
    PageName,
    pageNameAtom,
    sellerAtom,
    floatingChatDataAtom,
    type FloatingChatData,
} from '@fiverr-private/seller_pages_toolbox';
import { LoyaltyRolloutsProvider, MARLINS_LOYALTY_SUNSET } from '@fiverr-private/loyalty_indication';
import { RolloutContextData, RolloutContextProvider } from '../contexts/RolloutContext';
import { Seller } from '../types';
import { CurrencyConfig } from '../types/localization-kimera';
import { queryClient as defaultQueryClient } from './queryClient';

export interface AppProvidersLayerProps {
    rollouts: RolloutContextData;
    currency: CurrencyConfig;
    seller: Seller;
    queryClient?: QueryClient;
    floatingChatData: FloatingChatData;
}

export const AppProvidersLayer: React.FC<React.PropsWithChildren<AppProvidersLayerProps>> = ({
    rollouts = {},
    currency,
    queryClient = defaultQueryClient,
    seller,
    floatingChatData,
    children,
}) => (
    <AtomsProvider
        atoms={[
            [sellerAtom, seller],
            [pageNameAtom, 'business_seller_page' as PageName],
            [floatingChatDataAtom, floatingChatData],
        ]}
    >
        <QueryClientProvider client={queryClient}>
            <RolloutContextProvider value={rollouts}>
                <LoyaltyRolloutsProvider
                    value={{ [MARLINS_LOYALTY_SUNSET]: !!rollouts?.inMarlinsLoyaltySunsetRollout }}
                >
                    <LocalizationContextProvider currency={currency}>{children}</LocalizationContextProvider>
                </LoyaltyRolloutsProvider>
            </RolloutContextProvider>
        </QueryClientProvider>
    </AtomsProvider>
);
